import React from "react";
import {
  FaLinkedin,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Contact = () => {
  return (
    <section id="Contact" className="py-12 px-4">
      <div className="container mx-auto max-w-3xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-400 mb-2">Contact Me</h2>
          <p className="text-gray-500">
            Let's connect and create something amazing together
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {/* Email Card */}
          <div className=" p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <FaEnvelope className="text-blue-600 text-xl" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-100">Email</h3>
                <a
                  href="mailto:prasad.savadatti@gmail.com"
                  className="text-blue-600 hover:underline"
                >
                  prasad.savadatti@gmail.com
                </a>
              </div>
            </div>
            <button
              onClick={() =>
                (window.location.href = "mailto:prasad.savadatti@gmail.com")
              }
              className="mt-4 w-full py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Send Email
            </button>
          </div>

          {/* Phone Card */}
          <div className=" p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <FaPhone className="text-green-600 text-xl" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-100">Phone</h3>
                <a href="tel:+916361056819" className="text-gray-100">
                  +91 6361056819
                </a>
              </div>
            </div>
            <button
              onClick={() => (window.location.href = "tel:+916361056819")}
              className="mt-4 w-full py-2 border border-green-600 text-green-600 rounded-lg hover:bg-green-50"
            >
              Call Now
            </button>
          </div>
        </div>

        {/* LinkedIn */}
        <div className=" p-6 rounded-xl shadow-md border border-gray-200 mb-8">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <FaLinkedin className="text-blue-600 text-xl" />
              </div>
              <div>
                <h3 className="font-semibold text-blue-800">
                  LinkedIn Profile
                </h3>
                <p className="text-gray-100">Connect with me professionally</p>
              </div>
            </div>
            <a
              href="https://www.linkedin.com/in/prasad-savadatti-9262a8a5/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              View Profile
            </a>
          </div>
        </div>

        {/* Simple Message */}
        <div className="text-center p-6 bg-blue-50 rounded-xl">
          <p className="text-gray-700">
            <span className="font-semibold">Currently available</span> Let's
            discuss how I can help your business grow!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
